var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 4.82463L11.7155 3.20668C11.44 2.93111 10.9932 2.93111 10.7176 3.20668L9.09967 4.82463M11.2166 3.41335L11.2166 11.881",
    stroke: "#277E8B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98291 11.1755L5.36496 12.7935C5.08939 13.069 4.6426 13.069 4.36704 12.7935L2.74908 11.1755M4.866 12.5868L4.866 4.11914",
    stroke: "#BBBDC0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingAscending);
export default __webpack_public_path__ + "static/media/sorting-ascending.52aebd3dc563209373e916e37e38dc1f.svg";
export { ForwardRef as ReactComponent };